var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon-base",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.height,"viewBox":['0 0', _vm.viewBoxWidth, _vm.viewBoxHeight],"width":_vm.width,"aria-labelledby":_vm.iconName,"role":"presentation","fill":"none"}},[_c('g',{attrs:{"fill":_vm.iconColor,"opacity":_vm.opacity}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }